import React from 'react'
// import logo1 from "./../../assets/card-logos/amazon-pay.jpg"
// import logo2 from "./../../assets/card-logos/american-express.jpg"
// import logo3 from "./../../assets/card-logos/masterCard.jpg"
// import logo4 from "./../../assets/card-logos/paypal.jpg"
// import googlePlayIcon from "../../assets/images/googleplay.png"
// import appStoreIcon from "../../assets/images/appstore.png"
import { Link } from 'react-router-dom'
import { FaFacebook, FaGithub, FaInstagram, FaTwitter } from 'react-icons/fa'
import ScrollToTopBTN from '../ScrollToTopBTN/ScrollToTopBTN.jsx'

export default function Footer() {
  return <>
    <footer className="bg-gray-200 relative">
    <ScrollToTopBTN />
      <div className="grid grid-cols-2 gap-8 px-6 py-8 md:grid-cols-4">
        <div>
          <h2 className="mb-6 text-sm font-semibold text-green-500 uppercase ">Company</h2>
          <ul className="text-gray-500">
            <li className="mb-4">
              <Link to="/" className=" hover:underline">About</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Careers</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Brand Center</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Blog</Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="mb-6 text-sm font-semibold text-green-500 uppercase">Help center</h2>
          <ul className="text-gray-500">
            <li className="mb-4">
              <Link to="/" className="hover:underline">Discord Server</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Twitter</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Facebook</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Contact Us</Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="mb-6 text-sm font-semibold text-green-500 uppercase">Legal</h2>
          <ul className="text-gray-500">
            <li className="mb-4">
              <Link to="/" className="hover:underline">Privacy Policy</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Licensing</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Terms &amp; Conditions</Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="mb-6 text-sm font-semibold text-green-500 uppercase">Download</h2>
          <ul className="text-gray-500">
            <li className="mb-4">
              <Link to="/" className="hover:underline">iOS</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Android</Link>
            </li>
            <li className="mb-4">
              <Link to="/" className="hover:underline">Windows</Link>
            </li>
            <li className="mb-4">
              {/* <Link to="/" className="hover:underline">MacOS</Link> */}
            </li>
          </ul>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-100  md:flex md:items-center md:justify-between">
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <span className="text-sm text-gray-500  sm:text-center">Designed and Developed by <a href="https://www.facebook.com/profile.php?id=100014025102184" target='_blank' className='text-green-500'>Mohamed Saber</a> © 2023 FreshCart. All Rights Reserved.
        </span>
        <div className="flex mt-4 space-x-6 sm:justify-center md:mt-0">
          <Link to="/" className="text-gray-400 hover:text-gray-900">
            <FaFacebook />
            <span className="sr-only">Facebook page</span>
          </Link>
          <Link to="/" className="text-gray-400 hover:text-gray-900">
            <FaInstagram />
            <span className="sr-only">Instagram page</span>
          </Link>
          <Link to="/" className="text-gray-400 hover:text-gray-900">
            <FaTwitter />
            <span className="sr-only">Twitter page</span>
          </Link>
          <Link to="/" className="text-gray-400 hover:text-gray-900">
            <FaGithub />
            <span className="sr-only">GitHub account</span>
          </Link>
        </div>
      </div>
    </footer>
  </>
}
